<style>
    .error {
        color: #ff4444;
    }
</style>

<fadv-box [formGroup]="formGroup">
    <fadv-grid>
        <fadv-grid-row>
            <fadv-grid-col alignment="left">
                <fadv-typography type="label-medium" weight="500">Add Employment</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col alignment="center">
                <fadv-alternate-alert #employmentAlert variant='danger'>Please ensure your employer data is valid</fadv-alternate-alert>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col>
                <fadv-checkbox (checkedChange)="checkedCurrentEmployer($event)" formControlName="isCurrentEmployer">This is my current employer</fadv-checkbox>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col col="12" alignment="left">
                <fadv-input (blur)="showValidation('employerName')" formControlName="employerName"
                 type="text" label="Employer Name*"></fadv-input>
                <span class="error" *ngIf="this.employerNameInvalid">
                    <small *ngIf="formGroup.get('employerName').hasError('required')">Employer Name is Required</small>
                    <small *ngIf="formGroup.get('employerName').hasError('whitespace') && !formGroup.get('employerName').hasError('required')">Employer Name Cannot be Empty</small>
                  </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-date-picker #fadvDatePickerStartDate
                [invalid]="startDateInvalid" (blur)="handleStartDate($event)" [clearable]="true"
                [max]="today" label="Start Date*" variant="primary"></fadv-date-picker>
                <div>
                    <span *ngIf="this.startDateInvalid">
                        <small *ngIf="this.startDate.hasError('required')" class="text-danger">Please enter a valid start date</small> 
                    </span>
                </div>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-date-picker #fadvDatePickerEndDate
                [invalid]="endDateInvalid" (blur)="handleEndDate($event)" 
                [clearable]="true" [readonly]="current" [disabled]="current"
                [max]="today" label="{{ isCurrentEmployer ? 'End Date' : 'End Date*' }}" variant="primary"></fadv-date-picker>
                <div>
                    <span *ngIf="this.endDateInvalid">
                        <small *ngIf="this.endDate.hasError('required')" class="text-danger">Please enter a valid end date</small> 
                    </span>
                </div>
            </fadv-grid-col>
        </fadv-grid-row>
            <fadv-grid-row>
                <fadv-grid-col col="12" alignment="left">
                    <fadv-input (blur)="showValidation('position')" formControlName="position"
                     type="text" label="Position*"></fadv-input>
                    <span class="error" *ngIf="this.positionInvalid">
                        <small *ngIf="formGroup.get('position').hasError('required')">Position is Required</small>
                        <small *ngIf="formGroup.get('position').hasError('whitespace') && !formGroup.get('position').hasError('required')">Position Cannot be Empty</small>
                      </span>
                </fadv-grid-col>
                <fadv-grid-col col="12" alignment="left">
                    <fadv-input (blur)="showValidation('city')" formControlName="city"
                     type="text" label="City*"></fadv-input>
                    <span class="error" *ngIf="this.cityInvalid">
                        <small *ngIf="formGroup.get('city').hasError('required')">City is Required</small>
                        <small *ngIf="formGroup.get('city').hasError('whitespace') && !formGroup.get('city').hasError('required')">City Cannot be Empty</small>
                      </span>
                </fadv-grid-col>
            </fadv-grid-row>
            <fadv-grid-row>
                <fadv-grid-col col="12" alignment="left">
                    <fadv-select formControlName="state" label="State*" hoist="true" scrollable="true">
                        <fadv-menu-item *ngFor="let state of states" value="{{state.code}}">{{ state.name }}</fadv-menu-item>
                    </fadv-select>
                </fadv-grid-col>
                <fadv-grid-col col="12" alignment="left">
                    <fadv-input (blur)="showValidation('phone')" formControlName="phone"
                     type="text" label="Phone*" maxlength="10" minlength="10"></fadv-input>
                    <span class="error" *ngIf="this.phoneInvalid">
                        <small *ngIf="formGroup.get('phone').hasError('required')">Phone is Required</small>
                        <small *ngIf="formGroup.get('phone').hasError('minlength') || candidate.get('phone').hasError('pattern')" class="text-danger">Phone Number must be 10 Digits</small>
                      </span>
                </fadv-grid-col>
            </fadv-grid-row>
            <!-- <fadv-grid-row>
                <fadv-grid-col alignment="right" [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                    <fadv-box>
                        <fadv-button pill="true" [disabled]="loading || this.employmentFormInvalid || this.disableEmploymentButton" size="medium" variant="primary" (click)="addEmployer()" type="button">Add Employer</fadv-button>
                    </fadv-box>
                </fadv-grid-col>
                <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                    <fadv-box>
                        <fadv-button pill="true" [disabled]="loading" size="medium" (click)="cancel()" type="button">Reset</fadv-button>
                    </fadv-box>
                </fadv-grid-col>
            <fadv-grid-row>
                <fadv-grid-col [col]="{ xxl: 10, xl: 9, lg: 9, md: 8, sm: 12, xs: 12 }">
                    <fadv-box [mb]="{ sm: 'medium', xs: 'medium' }">
                        <fadv-tag *ngFor="let previousEmployer of previousEmployers;" removable="true" size="large" pill="true" (removed)="removePreviousEmployer(previousEmployer)" variant="success">
                        {{previousEmployer.position}} at {{ previousEmployer.employerName }}</fadv-tag>
                    </fadv-box>
                </fadv-grid-col>
                </fadv-grid-row>
            </fadv-grid-row> -->
    </fadv-grid>
</fadv-box>
